import { render, staticRenderFns } from "./IconSvg.vue?vue&type=template&id=23415fc4&scoped=true&"
import script from "./IconSvg.vue?vue&type=script&lang=js&"
export * from "./IconSvg.vue?vue&type=script&lang=js&"
import style0 from "./IconSvg.vue?vue&type=style&index=0&id=23415fc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23415fc4",
  null
  
)

export default component.exports